
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
components: {
Checker,
CheckerItem
},
name: 'maternal_form_a_edit',
data(){
return{
get_host:host.host,
type:'',
showSignature:true,
showUserSignature:true,
form:{
maternal_nursing_check:[]
},
option:{
penColor:"rgb(0, 0, 0)"
},
}
},
methods:{

save(){
let signature ='signature1'
console.info(this.$refs[signature])
let png = this.$refs[signature].save()
this.form.autograph = encodeURI(png)
this.showSignature = true
},

edit(){
this.showSignature = false
this.form.autograph = ''
},

clear(){
let signature ='signature1'
let refs = this.$refs[signature].clear()
this.form.autograph = ''
},

saveUserName(){
let signature ='signature2'
console.info(this.$refs[signature])
let png = this.$refs[signature].save()
this.form.customer_sign = encodeURI(png)
this.showUserSignature = true
},

editUserName(){
this.showUserSignature = false
this.form.customer_sign = ''
},

clearUserName(){
let signature ='signature2'
let refs = this.$refs[signature].clear()
this.form.customer_sign = ''
},

submitForm(){
this.form.token=this.$cookie.get('token')
this.form.number_id=this.$cookie.get('id')
this.form.maternal_info_id=this.$route.query.id
this.form.id=this.$route.query.form_id
this.form.store_id=this.$cookie.get('store_id')
this.form.autograph=this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host,'') : this.form.autograph
this.form.customer_sign=this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host,'') : this.form.customer_sign
let params = this.form
if(
params.room_number==''||params.entry_time==''||params.name==''||params.age==''||params.blood_type==''||params.national==''||params.native_place==''||params.maternity_hospital==''||
params.maternity_date==''||params.maternity_type==''||params.leave_hos_smary==''||params.medication_history==''||params.allergy_history==''||params.leave_hos_diagnosis==''||
params.pregnancy_illness==''||params.maternity_special_case==''||params.acute_disease_treat==''||params.contagion_stage==''||params.spirit_history==''||params.heart_assess==''||
params.character_type==''||params.emotion==''||params.appetite==''||params.diet_require==''||params.diet_hobby_status==''||
params.allergy_food==''||params.micturition_case==''||params.micturition_num==''||params.urination_pain==''||params.defecation_case==''||
params.do_recovery_know==''||params.attend_pregnancy_edu==''||params.family_do_maternal_att==''||params.temperature==''||params.blood_pressure==''||
params.pulse_num==''||params.breathing_num==''||params.weight==''||params.complexion==''||params.mouth_mucosa==''||params.activity==''||params.lochia_colour==''||params.lochia_amount==''||
params.lochia_sniff==''||params.lochia_gdg==''||params.incision_case==''||params.incision_case_desc==''||params.breast_case==''||params.papilla_case==''||params.milk_case==''||
params.milk_other_case==''||params.special_find==''||params.maternal_nursing_check.length==0||params.autograph==''||params.customer_sign==''||params.assess_time==''
){
this.$vux.toast.show({
type: 'cancel',
text: '请完善表单',
})
return
}
console.info(params)
this.$vux.loading.show({
text: '正在加载'
})
Api.otherFormApi.updateMaterCheckAssessData(params).then ( res => {
this.$vux.loading.hide()
console.info(res)
if(res.errcode==200){
this.$router.replace({
path:'/success',
query:{
id:this.$route.query.id,
tabVal: this.$route.query.tabVal,
form_id:res.data.id,
name : 'maternal_form_a',
}
})
}
})
},
goBack(){
this.$router.push({
path: './maternal_service',
query: {
tabVal: this.$route.query.tabVal,
id: this.$route.query.id
}
})
}
},
created(){
let params ={
token:this.$cookie.get('token'),
id:this.$route.query.form_id
}
this.$vux.loading.show({
text: '正在加载'
})
console.info(params)
Api.otherFormApi.getMaterCheckAssessFind(params).then (res => {
this.$vux.loading.hide()
console.info("详情",res.data)
if(res.errcode==200){
this.form=res.data
this.form.maternal_nursing_check=res.data.maternal_nursing_check
this.form.autograph=res.data.autograph.indexOf(this.get_host) != -1 ? res.data.autograph : this.get_host+res.data.autograph
this.form.customer_sign=res.data.customer_sign.indexOf(this.get_host) != -1 ? res.data.customer_sign : this.get_host+res.data.customer_sign
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/maternal_form_a_edit.vue